import Vue from 'vue';
import Vuex from 'vuex';

import root from './rootStore';

import indexView from './modules/indexStore';
import videoDetailStore from './modules/videoDetailStore';
import liveVideo from './modules/liveVideoStore';
import recommend from './modules/recommendStroe';
import serach from './modules/serachStroe';
import comment from './modules/commentStore';
import PersonalCenter from './modules/PersonalCenterStore';
import params from './modules/params';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    ...root,

    modules: {

        indexView,
        videoDetailStore,
        liveVideo,
        recommend,
        serach,
        comment,
        PersonalCenter,
        params,
    },
});
